var _defs, _rect, _g, _path, _path2, _path3, _polyline, _polyline2, _path4, _path5, _path6, _polyline3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.9 52.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#414042;}.c{clip-path:url(#a);}.d{fill:#fff;}.e{fill:url(#b);}.f{fill:url(#c);}.g{fill:url(#d);}.h{fill:url(#e);}.i{fill:url(#f);}.j{fill:url(#g);}.k{fill:url(#h);}.l{fill:url(#i);}.m{fill:url(#j);}.n{fill:url(#k);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.67,51H11A11.1,11.1,0,0,1,0,39.68v-28A11,11,0,0,1,11,1H69.67a11,11,0,0,1,11,11V40A11,11,0,0,1,69.67,51Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -181.39,
    cy: -275.21,
    r: 82.57,
    gradientTransform: "translate(192.44 282.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#009aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#008fbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#006d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00607e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 15.13,
    cy: -1.3,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 15.13,
    cy: -1.3,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 15.13,
    cy: -1.3,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 15.13,
    cy: -1.3,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 15.13,
    cy: -1.29,
    r: 83.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 15.13,
    cy: -1.29,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 15.13,
    cy: -1.3,
    r: 83.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 15.13,
    cy: -1.29,
    r: 83.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 15.13,
    cy: -1.3,
    r: 83.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AmericanExpress_shadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.24,
    y: 2.11,
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 80.67,
    height: 51.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.54,39.42h-5.7V39a5.06,5.06,0,0,1-1.91.38H61.45v0H48.36v-1.6s0-1.14,0-1.35H48v2.95H42.66V36.24a7.68,7.68,0,0,1-2.85.45H39.3v2.73H33L31.4,37.68l-1.59,1.74H19.48V27.71H29.63l1.78,1.94,1.78-1.93h7.53a4.85,4.85,0,0,1,1.94.29v-.27h6.77a4.76,4.76,0,0,1,2.09.33v-.33h9.92v.34a4.88,4.88,0,0,1,1.93-.35H69v.36a4.84,4.84,0,0,1,2-.36h6.24l.08,7.19,3.36,16.75V0H0V25H2.9L8,13.33h5.16l.62,1.47V13.33h6l1.34,3,1.33-3H41.11a4.76,4.76,0,0,1,2.09.33v-.33h5.37V14a5.34,5.34,0,0,1,2.59-.78l3,.08h5.15l.57,1.37V13.33h5.55l.88,1.46V13.33h5.37V25H66.18l-.92-1.53V25H58.38l-.76-1.78H55.79L55,25H50.49l-.11,0a4.84,4.84,0,0,1-1.81-.71v.76H44.79v0H40V22.08h-.35V25H23.1v-.18L23,25H19.21l-.1-.22V25H12.19l-.75-1.78H9.62L8.86,25H0V51.67H80.67L77.31,34.92C77.22,38.17,73.38,39.42,72.54,39.42Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M41.66,23.43V21.77a1.39,1.39,0,0,0-1.44-1.29h-2.1v2.95H36v-8.5H41.2a2.36,2.36,0,0,1,2.73,2.49,2.17,2.17,0,0,1-1.21,2,2.08,2.08,0,0,1,1,1.93v2.1H41.66m-3.54-4.95h2.23c.65,0,1.18-.36,1.18-.81s-.53-.81-1.18-.81H38.12v1.61h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M67.11,23.43l-3.42-5.68v5.68H59.46l-.76-1.78H54.76L54,23.43H50.63s-2.9-.42-2.9-4c0-4.72,3.29-4.53,3.41-4.56l2.66.07v1.91l-2.18,0s-1.42,0-1.6,1.86a5.75,5.75,0,0,0,0,.59c0,2.87,2.49,2,2.57,2l2.67-6.34h3l3.23,7.71V14.93h3l3.38,5.59V14.93h2.17v8.5h-3m-11.43-4h2.1l-1-2.53-1.06,2.53h0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M24.73,23.43V17.56L22,23.43H20.26l-2.72-5.84v5.84H13.28l-.75-1.78H8.6l-.76,1.78H5.48l3.58-8.5h3l3.28,7.81V14.93h3.41l2.37,5.28,2.36-5.28h3.41v8.5H24.73m-15.22-4h2.1l-1-2.53L9.52,19.47h0"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "i",
    points: "28.11 23.43 28.11 14.93 34.84 14.93 34.84 16.91 30.28 16.91 30.28 18.22 34.73 18.22 34.73 20.15 30.28 20.15 30.28 21.59 34.84 21.59 34.84 23.43 28.11 23.43"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "j",
    points: "44.82 23.45 44.82 14.93 46.99 14.93 46.99 23.45 44.82 23.45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M50,37.84V36.18a1.39,1.39,0,0,0-1.44-1.29h-2.1v2.95H44.29v-8.5h5.24a2.36,2.36,0,0,1,2.73,2.49,2.17,2.17,0,0,1-1.21,2,2.08,2.08,0,0,1,1,1.93v2.1H50m-3.54-4.95h2.23c.65,0,1.18-.36,1.18-.81s-.53-.81-1.18-.81H46.45v1.61h0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M35.6,37.82H33.72L31.43,35.3l-2.3,2.52h-8V29.31H29L31.43,32l2.49-2.69h6.89a2.38,2.38,0,0,1,2.73,2.5c0,2.5-.91,3.28-3.7,3.28H37.73v2.73H35.6m-2.7-4.18,2.67,3V30.69L32.9,33.64h0M23.28,36h4.54L30,33.64l-2.13-2.33H23.28v1.31h4.43v1.93H23.28V36h0m14.45-3.11H40c.65,0,1.18-.36,1.18-.81s-.53-.81-1.18-.81H37.73v1.61h0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M64.7,37.81H60.86v-2h3.37s1.21.14,1.21-.67-1.83-.71-1.83-.71-3,.26-3-2.53a2.49,2.49,0,0,1,2.69-2.62h4.14v2H64.12S63,31.08,63,31.91s1.57.6,1.57.6,3.29-.24,3.29,2.32a2.7,2.7,0,0,1-2.87,3H64.7"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "n",
    points: "53.15 37.82 53.15 29.34 59.88 29.34 59.88 31.31 55.32 31.31 55.32 32.61 59.77 32.61 59.77 34.54 55.32 34.54 55.32 35.98 59.88 35.98 59.88 37.82 53.15 37.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M72.31,37.81H68.47v-2h3.35S73,36,73,35.18s-1.83-.71-1.83-.71-3,.26-3-2.53a2.49,2.49,0,0,1,2.69-2.62h4.13v2H71.73s-1.15-.23-1.15.61,1.57.6,1.57.6,3.29-.24,3.29,2.32a2.7,2.7,0,0,1-2.87,3h-.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/AmericanExpress.c98a7fbed4ab40d0ce9c8e4dd892ef57.svg";
export { ForwardRef as ReactComponent };